<template>
  <BaseButton :variant="variant" @click="$emit('click')">
    <BaseIcon v-if="isShowIcon" icon-name="edit" :width="iconWidth" :height="iconHeight">
      <IconEdit></IconEdit>
    </BaseIcon>
    <slot></slot>
  </BaseButton>
</template>

<script>
import buttonMixin from '@/mixins/button';
import BaseIcon from '@/components/BaseIcon.vue';
import IconEdit from '@/components/icon/IconEdit.vue';

export default {
  mixins: [buttonMixin],
  components: {
    BaseIcon,
    IconEdit,
  },
  props: {
    variant: { type: String, default: 'primary' },
  },
};
</script>

<style lang="scss" scoped></style>
